import { DonationTextBox, DonationFormLabel, DonationFormInput } from './DonationTextField.styles';

interface DonationTextFieldProps {
  htmlFor: string,
  labelText: string,
  placeholder: string,
  required: boolean,
  value?: string,
  email?: boolean,
  tel?: boolean,
  number?: boolean,
  setTextField: (field: string) => void
}

function DonationTextField(props: DonationTextFieldProps) {
  const {htmlFor, value, labelText, placeholder, required, email, tel, number, setTextField} = props;
  const phonePattern = '^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$';

  return (
    <DonationTextBox>
      <DonationFormLabel htmlFor={htmlFor}>
        {labelText}
      </DonationFormLabel>
      <DonationFormInput
        id={htmlFor} 
        type={
          number ? 'number' :
          email ? 'email' :
          tel ? 'tel' :
          'text'
        }
        placeholder={placeholder} 
        pattern={tel ? phonePattern : undefined}
        required={required} 
        onChange={e => setTextField(e.currentTarget.value)}
        value={value}
      />
    </DonationTextBox>
  )
}

export default DonationTextField;
